<template>
  <ValidationProvider name="User List" slim vid="ga_user_list_id" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="ga_user_list_id"> User List </BaseFormLabel>
        <VSelect
          id="ga_user_list_id"
          v-model="gaUserListId"
          :options="options"
          label="name"
          :reduce="(option) => option.id"
          :disabled="disabled"
          class="vue-select custom-option"
          :filterable="false"
          @search="onSearch"
        >
          <template #option="{ id, name }">
            <div class="group px-4 py-2">
              <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                {{ name }}
              </p>
              <span class="text-gray-400 group-hover:text-indigo-200 text-xs">{{ id }}</span>
            </div>
          </template>
          <template v-if="hasMore" #list-footer>
            <li class="flex space-x-2">
              <BaseButton
                primary
                outline
                small
                :disabled="!hasPrevPage"
                class="flex-1"
                @click="fetchPrevPage"
              >
                Prev
              </BaseButton>
              <BaseButton
                primary
                outline
                small
                :disabled="!hasNextPage"
                class="flex-1"
                @click="fetchNextPage"
              >
                Next
              </BaseButton>
            </li>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import { googleAdsUserListsClient } from '@/api/clients';
import { debounce } from 'lodash-es';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    gaCustomerId: {
      type: Number,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      options: [],
      meta: null,
      search: '',
      page: 1,
    };
  },
  computed: {
    gaUserListId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasMore() {
      return (this.meta?.total || 0) > (this.meta?.per_page || 0);
    },
    hasPrevPage() {
      return (this.meta?.current_page || 1) > 1;
    },
    hasNextPage() {
      return (this.meta?.last_page || 1) > (this.meta?.current_page || 1);
    },
  },
  created() {
    this.fetchOptions();
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.searchOptions(loading, search, this);
    },
    searchOptions: debounce((loading, search, vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.search = search;
      // eslint-disable-next-line no-param-reassign
      vm.page = 1;
      vm.fetchOptions().finally(() => loading(false));
    }, 350),
    async fetchOptions() {
      try {
        const response = await googleAdsUserListsClient.list({
          filter: {
            search: this.search,
            ga_customer_id: this.gaCustomerId,
          },
          page: this.page,
        });

        this.options = response.data;
        this.meta = response.meta;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    fetchPrevPage() {
      if (!this.hasPrevPage) {
        return;
      }
      this.page = this.meta.current_page - 1;
      this.fetchOptions();
    },
    fetchNextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.page = this.meta.current_page + 1;
      this.fetchOptions();
    },
  },
};
</script>
